/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

/**
 * Переключит виджеты в состояние OFF, если их удалили из списка в меню настроек
 * Если виджет новый, то переключает его в состояние ON
 * @param newSpace
 * @param oldSpace
 */

const updateChartSelected = (newSpace: Space, oldSpace: Space): Space => {
  const selections = newSpace.chartSelected || {current: [], previous: []};
  const {current, previous} = selections;
  const newWidgetSet = newSpace.widgetsBoardSelected || [];
  const oldWidgetSet = oldSpace.widgetsBoardSelected || [];

  const newCurrentWidgetIds: ChartIds[] = [];
  const newPreviousWidgetIds: ChartIds[] = [];

  current.forEach(id => {
    if (newWidgetSet.includes(id)) {
      newCurrentWidgetIds.push(id);
    }
  });

  previous.forEach(id => {
    if (newWidgetSet.includes(id)) {
      newPreviousWidgetIds.push(id);
    }
  });

  newWidgetSet.forEach(id => {
    if (!current.includes(id) && !oldWidgetSet.includes(id)) {
      newCurrentWidgetIds.push(id);
    }
  });

  return {
    ...newSpace,
    chartSelected: {
      current: newCurrentWidgetIds,
      previous: newPreviousWidgetIds,
    },
  };
};

export default updateChartSelected;
